export const RECONCILER_NAME = '@tarojs/plugin-framework-solid/dist/reconciler'
